// extracted by mini-css-extract-plugin
export default {"screen-wrap-item":"index_screen-wrap-item__dA5-G"};